import cn from 'classnames';
import styles from './infoBox.scss';

interface InfoBoxProps {
  title: string;
  texts: string[] | string;
}

export const InfoBox = ({ title, texts }: InfoBoxProps) => {
  const isList = texts.length > 1;

  return (
    <div
      className={cn(styles.infoBox, {
        [styles.single]: !isList,
        [styles.list]: isList
      })}
    >
      <div className={styles.title}>{title}</div>
      <div className={styles.divider} />
      {Array.isArray(texts) ? (
        texts.map(text => (
          <div key={text} className={styles.text}>
            <span className={styles.marker} />
            <span>{text}</span>
          </div>
        ))
      ) : (
        <div key={texts} className={styles.text}>
          <span>{texts}</span>
        </div>
      )}
    </div>
  );
};
